"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PERMISSION_TYPES = void 0;
const PERMISSION_TYPES = ['tenant:read', 'tenant:update', 'tenant:delete', 'application:read', 'application:create', 'application:update', 'application:create', 'reactor:read', 'reactor:create', 'reactor:update', 'reactor:delete', 'log:read', 'token:read', 'token:create', 'token:delete', 'token:decrypt', 'card:read', 'card:create', 'card:update', 'card:delete', 'bank:read', 'bank:create', 'bank:update', 'bank:delete', 'bank:decrypt'];
exports.PERMISSION_TYPES = PERMISSION_TYPES;